import React from "react";
import { styled } from "@mui/system";
import MUIMenuItem, { MenuItemProps } from "@mui/material/MenuItem";

export const MenuItem = styled(
  (props: MenuItemProps) => <MUIMenuItem {...props} />,
  {
    name: "MenuItem",
    slot: "Root",
    overridesResolver: (props, styles) => [],
  }
)(({ theme }) => ({
  paddingTop: "10px",
  paddingBottom: "10px",
  "&.MuiMenuItem-root.MuiButtonBase-root": {
    "&:hover": {
      background: theme.palette.primary.surfaceDefault,
      border: "1px solid #0090D1",
    },
  },
}));
